import { render, staticRenderFns } from "./VisitPolicy.vue?vue&type=template&id=032b1cd4&scoped=true"
import script from "./VisitPolicy.vue?vue&type=script&lang=js"
export * from "./VisitPolicy.vue?vue&type=script&lang=js"
import style0 from "./VisitPolicy.vue?vue&type=style&index=0&id=032b1cd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032b1cd4",
  null
  
)

export default component.exports